const navbar = {
  getRecipe: [
    {
      id: 'matisse_lite',
      label: 'Matisse Lite',
      key: 'MATISSE_LITE',
      tooltip: 'The simplified digital workflow for your everyday cases.',
      children: [
        {
          id: 'dentin_enamel',
          label: 'Dentin & Enamel',
          route: '/matisse-lite/dentin_enamel',
          key: 'MATISSE_LITE',
          activeStep: 1,
          tooltip: 'Dentin & Enamel',
        },
        {
          id: 'staining_studio',
          label: 'Stain & Glaze',
          route: '/matisse-lite/staining-studio',
          key: 'STAIN_&_GLAZE',
          activeStep: 2,
          tooltip: 'Stain & Glaze',
        },
      ],
    },
    {
      id: 'all-in-one-recipe',
      label: 'All-In-One Recipe',
      route: '/all-in-one',
      key: 'GENERIC',
      tooltip: 'Get quick recipes for all indications at one go.',
    },
    {
      id: 'analog',
      label: 'ShadeGuide AI',
      route: '/shade-guide-ai',
      key: 'SHADEGUIDEAI',
      badge: 'Beta',
      tooltip: 'Get recipes with jpeg images of shadetabs.',
    },
  ],

  wizards: [
    {
      id: 'model-making',
      label: 'Model Making',
      key: 'MODEL_MAKING',
      tooltip:
        'Wizard to prepare a 3D printed model mimimicking the mouth situation.',
      children: [
        {
          id: 'Stumpshade',
          label: 'Resin Recipe',
          route: '/model-making/resin-recipe',
          key: 'AESTHETIC_MODEL',
          activeStep: 1,
          tooltip: 'Get recipes for stump shade material.',
        },
        {
          id: 'Stumpshade_staining',
          label: '3D Printed Model Staining',
          route: '/model-making/3d-printed-model-staining',
          key: '3D_PRINTED_MODEL_STAINING',
          activeStep: 2,
          tooltip: 'Get staining recipes to improve the stump shade.',
        },
      ],
    },
    {
      id: 'full-layering',
      label: 'Full Layering',
      key: 'FULL_LAYERING',
      tooltip: 'Step-by-step workflow for making full ceramic restorations.',
      children: [
        {
          id: 'Framework',
          label: 'Framework',
          route: '/full-layering/framework',
          key: 'FRAMEWORK',
          activeStep: 1,
          tooltip: 'Get advice on Zirkonia and Lithium disicilicate.',
        },
        {
          id: 'Washbake',
          label: 'Wash Bake',
          route: '/full-layering/wash-bake',
          key: 'WASHBAKE',
          activeStep: 2,
          tooltip: 'Get staining recipes to correct chroma of the framework.',
        },
        {
          id: 'Dentin',
          label: 'Dentin',
          route: '/full-layering/dentin',
          key: 'DENTIN',
          activeStep: 3,
          tooltip: 'Get ceramic recipes for the dentin layer.',
        },
        {
          id: 'Internal_effects',
          label: 'Internal Effects',
          route: '/full-layering/internal-effects',
          key: 'INTERNAL',
          activeStep: 4,
          tooltip: 'Get ceramic recipes for internal details.',
        },
        {
          id: 'Staining_corrections',
          label: 'Staining Studio',
          route: '/full-layering/staining-corrections',
          key: 'STAINING_STUDIOS',
          activeStep: 5,
          tooltip: 'Get internal staining recipes for final color corrections.',
        },
        {
          id: 'Enamel',
          label: 'Enamel',
          route: '/full-layering/enamel',
          key: 'ENAMEL',
          activeStep: 6,
          tooltip: 'Get enamel advice to finish the ceramic restoration.',
        },
      ],
    },
    {
      id: 'micro-layering',
      label: 'Micro Layering',
      key: 'MICRO_LAYERING',
      tooltip:
        'Step-by-step workflow for making restorations with minimal cut-back.',
      children: [
        {
          id: 'Material_advice',
          label: 'Framework',
          route: '/micro-layering/material-advice',
          key: 'FRAMEWORK',
          activeStep: 1,
          tooltip: 'Get advice on Zirkonia and Lithium disicilicate.',
        },
        {
          id: 'Staining',
          label: 'Staining Studio',
          route: '/micro-layering/staining',
          key: 'STAINING_STUDIOS',
          activeStep: 2,
          tooltip: 'Get staining recipes to match the natural tooth.',
        },
        {
          id: 'Internal_effects',
          label: 'Internal Effects',
          route: '/micro-layering/internal-effects',
          key: 'INTERNAL',
          activeStep: 3,
          tooltip: 'Get ceramic recipes for internal details.',
        },
        {
          id: 'Enamels',
          label: 'Enamel',
          route: '/micro-layering/enamel',
          key: 'ENAMEL',
          activeStep: 4,
          tooltip:
            'Get enamel advice to finish the minimal cut-back restoration.',
        },
      ],
    },
    {
      id: 'full-monolithic',
      label: 'Full Monolithic',
      key: 'FULL_MONOLITHIC',
      tooltip: 'Step-by-step workflow for making monolithic restorations.',
      children: [
        {
          id: 'Material_advice',
          label: 'Framework',
          route: '/full-monolithic/material-advice',
          key: 'FRAMEWORK',
          activeStep: 1,
          tooltip: 'Get advice on Zirkonia and Lithium disicilicate.',
        },
        {
          id: 'Staining',
          label: 'Staining Studio',
          route: '/full-monolithic/staining',
          key: 'STAINING_STUDIOS',
          activeStep: 2,
          tooltip: 'Get staining recipes to match the natural tooth.',
        },
      ],
    },
    {
      id: 'gingiva',
      label: 'Gingiva',
      key: 'GINGIVA',
      tooltip: 'Step-by-step workflow for making gingiva restorations.',
      badge: 'Beta',
      children: [
        {
          id: 'Gingiva_staining',
          label: 'Staining',
          route: '/gingiva/staining',
          key: 'GINGIVA_STAININGS',
          activeStep: 1,
          tooltip: 'Get staining recipes to match the gingiva tissue.',
        },
        {
          id: 'Ceramic',
          label: 'Ceramic',
          route: '/gingiva/ceramic',
          key: 'GINGIVA',
          activeStep: 2,
          tooltip: 'Get ceramic recipes to match the gingiva tissue.',
        },
      ],
    },
    {
      id: 'pfm-crown',
      label: 'PFM Crown',
      key: 'PFM_CROWN',
      tooltip: 'Step-by-step workflow for making PFM crowns.',
      children: [
        {
          id: 'Opaker',
          label: 'Opaquer',
          route: '/pfm-crown/opaquer',
          key: 'OPAQUER',
          activeStep: 1,
          tooltip: 'Get opaquer recipes.',
        },
        {
          id: 'Opaker_staining',
          label: 'Opaquer Staining',
          route: '/pfm-crown/opaquer-staining',
          key: 'OPAQUER_STAINING',
          activeStep: 2,
          tooltip: 'Get staining recipes to correct the opaquer chroma.',
        },
        {
          id: 'Dentin',
          label: 'Dentin',
          route: '/pfm-crown/dentin',
          key: 'DENTIN',
          activeStep: 3,
          tooltip: 'Get ceramic recipes for the dentin layer.',
        },
        {
          id: 'Internal_effects',
          label: 'Internal Effects',
          route: '/pfm-crown/internal-effects',
          key: 'INTERNAL',
          activeStep: 4,
          tooltip: 'Get ceramic recipes for internal details.',
        },
        {
          id: 'Staining_corrections',
          label: 'Staining Studio',
          route: '/pfm-crown/staining-corrections',
          key: 'STAINING_STUDIOS',
          activeStep: 5,
          tooltip: 'Get internal staining recipes for final color corrections.',
        },
        {
          id: 'PFM_Enamel',
          label: 'Enamel',
          route: '/pfm-crown/enamel',
          key: 'ENAMEL',
          activeStep: 6,
          tooltip: 'Get enamel advice to finish the PFM crown.',
        },
      ],
    },
  ],

  digitalData: [
    {
      id: 1,
      label: 'Color Checker',
      key: 'COLOR_CHECKER',
      route: '/digital-try-in?type=color_checker',
      tooltip: 'Digital try-in with Color Checker.',
    },
    {
      id: 2,
      label: 'Ceramic Studio',
      key: 'ENAMEL_STUDIO',
      route: '/digital-try-in?type=enamel_studio',
      tooltip: 'Digital try-in with Ceramic Studio.',
    },
  ],

  stainingStudioRecipe: [
    {
      id: 'full-monolithic-staining',
      label: 'Crown',
      route: '/staining-studio/crown',
      key: 'STAINING_STUDIO',
      tooltip: 'Get staining recipes for all restorations.',
    },
    {
      id: 'color-model-staining',
      label: 'Stump shade',
      route: '/staining-studio/stump-shade',
      key: 'COLORMODELSTAINING',
      tooltip: 'Get staining recipes for the stump shade.',
    },
    {
      id: 'Washbake',
      label: 'Wash bake',
      route: '/staining-studio/wash-bake',
      key: 'WASHBAKE',
      tooltip: 'Get framework staining recipes for the wash bake.',
    },
  ],
}
export default navbar
